import * as addressesTypes from "@vue-storefront/core/modules/user/store/address/mutation-types";
import checkoutInitialState from "@vue-storefront/core/modules/checkout/store/checkout/initial-state";
import updateObject from "@vue-storefront/core/scripts/utils/update-object";

function openAddressForm (store, state) {
  store.dispatch('shipping/updateShippingDetailsState', {
    shipToMyAddress: false,
    showNewAddressForm: true
  });
  state.checkout.shippingDetails = {};
  localStorage.setItem('shop/checkoutFieldValues/shipping-details', JSON.stringify(checkoutInitialState.shippingDetails));
}

function setNewMainAddress(store, state, setFirstAddressAsDefault = false) {
  const defaultAddress = setFirstAddressAsDefault
    ? state.address.addresses[0]
    : state.address.addresses.find(address => address.default_shipping);
  if (defaultAddress) {
    localStorage.setItem('shop/checkoutFieldValues/shipping-details', JSON.stringify(defaultAddress));
  }
  state.checkout.shippingDetails = updateObject(checkoutInitialState.shippingDetails, {
    ...defaultAddress
  });
  store.dispatch('shipping/updateShippingDetailsState', {
    shipToMyAddress: true,
    showNewAddressForm: false
  });
}

export default function afterUpdateEntity(store) {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      // addresses
      case `address/${addressesTypes.USER_ADDRESS_SET_LIST}`: {
        if (!state.address.addresses.length) {
          openAddressForm(store, state);
          break;
        }
        setNewMainAddress(store, state);
        break;
      }
      case `address/${addressesTypes.USER_ADDRESS_ADD}`: {
        if (state.address.addresses.length === 1) {
          store.dispatch('address/makeDefault', {
            address_id: state.address.addresses[0].id
          })
          setNewMainAddress(store, state, true);
        }
        break;
      }
      case `address/${addressesTypes.USER_ADDRESS_UPDATE}`: {
        setNewMainAddress(store, state);
        break;
      }
      case `address/${addressesTypes.USER_ADDRESS_DELETE}`: {
        if (!state.address.addresses.length) {
          openAddressForm(store, state);
          break;
        }
        // webStorage.ts also reacts to this same mutation by reloading the cart, but that
        // reload isn't awaited here and can reach the server before this makeDefault PATCH
        // persists the new default address - transiently pricing delivery as "no address".
        // Reload again once the new default is confirmed, so the price the customer ends up
        // seeing is never stuck on that transient state.
        store.dispatch('address/makeDefault', {
          address_id: state.address.addresses[0].id
        }).then(() => {
          store.dispatch('cart/load', { refreshTotals: true, isUpdate: true })
        })
      }
    }
  })
}
